<template>
	<div @click="fluidFun($event)" class="fluid yq_container pc_con">
		<!--myHeader></myHeader-->
		<div class="pos_con">
			<div class="inner">
				<template v-for="(i,index) in getDataCur.posCom" class="g-cf">
					<!--div :itemMdata="i" :posCom="'posCom'" :index="index" :id="i.allId" :class="[i.emitStr]" :is="i.tName"></div-->
					<mConet :itemMdata="i" :itemInner="getDataCur.posCom"></mConet>
				</template>
			</div>
		</div>
		<div :class="['conect_inner',{'warning':isConLeave}]" style="min-height: 500px; border: 1px solid #fff;">
			<div class="con_innd">
				<template v-for="(i,tIndex) in state.itemCon[state.delayed].stream" class="g-cf in_outer" :style="i.conStyle">
					<!--通栏排版-->
					<div :id="i.allId" :style="i.zinStyle" v-if="i.tName=='columnLayout'&&i.isShow" :class="['columnLayout', {'enter':i.isStreamColumn}]">
						<div :style="i.layoutOuterStyle" :class="['columnLayoutInner',{'enter':i.isStreamColumn}]">
							<div :id="tIndex" :style="{height:i.conStyle.height,minHeight:i.conStyle.minHeight,position:i.conStyle.position,margin:i.conStyle.margin}" class="layout_inner resizeMe">
								<mConet v-for="(irt,index) in i.itemInner" :key="index" :class="[{outmodule:irt.fullScreen}]" :itemMdata="irt" :itemInner="i"></mConet>
							</div>
						</div>
					</div>
					<!--标签展示-->
					<div v-if="i.tName=='labelContainer'&&i.isShow" class="columnLayout tabContainer" :style="i.zinStyle" :id="'labelContainerId'+tIndex">
						<div class="in_inner labelContainer" :style="i.ulStyle">
							<div class="g-cf tit_con" :class="[{labelListOne:i.diretionM==1,labelListTwo:i.diretionM==2,righterdUl:i.setulStyle==3&&i.diretionM==2}]" :style="i.layoutOuterStyle">
								<div class="g-cf titlbl" :style="i.marginStyle">
									<ul :class="['g-cf',{centerUl:i.setulStyle==1&&i.diretionM==1,leftUl:i.setulStyle==2&&i.diretionM==1,rightUl:i.setulStyle==3&&i.diretionM==1}]">
										<li v-for="(ite,index) in i.labelTitle" :class="[{'labelList':ite.labelTitle,'cur':ite.cur,'no_data':!ite.labelTitle}]" :style="[i.labelTitleStyle,{borderRadius:i.labelTitleStyle.borderRadius+'px',lineHeight:i.labelTitleStyle.height}]">
											<p class="title" :style="{borderRadius:i.labelTitleStyle.borderRadius+'px'}">{{ite.labelTitle}}</p>
											<i @click="deleteLabel(i,ite,index)"></i>
										</li>
									</ul>
								</div>
								<div class="lbl_con">
									<div v-for="(it,index) in i.labelTitle" class="conStyle" :style="it.conStyle" v-show="i.isShow">
										<template v-for="(ilbl,dex) in it.itemInner">
											<mConet :key="dex" :itemMdata="ilbl" :itemInner="it.itemInner"></mConet>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--自由容器-->
					<div :id="i.allId" v-if="i.tName=='freeContainer'&&i.isShow" :class="['in_inner freeContainer',{'enter':i.isStreamColumn}]" :style="[i.zinStyle,i.conStyle]">
						<div :style="i.conStyle">
							<mConet :key="index" v-for="(ite,index) in i.itemInner" :itemInner="i" :itemMdata="ite"></mConet>
						</div>
					</div>
					<!--多列排版-->
					<div :id="i.allId" v-if="i.tName=='multiColumnContainer'&&i.isShow" :class="['in_inner resizeMe multi_con g-cf', {'enter':i.isStreamColumn}]" :style="i.conStyle">
						<div v-for="(it,index) in i.labelTitle" v-if="it.isShow"  :style="[{height:i.conStyle.height,width:it.styleCon.width}]" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]">
							<div class="clm_inner" :style="i.conStyle">
								<div class="area_conn" :style="{padding:it.styleCon.padding}">
									<template v-for="(imy,inde) in it.itemInner">
										<mConet class="outmodule" :itemMdata="imy" :key="inde" :itemInner="it.itemInner"></mConet>
									</template>
								</div>
							</div>
						</div>
					</div>
					<!--滑屏容器-->
					<div :data-index="tIndex" v-if="i.tName=='swiperContainer'&&i.isShow" :class="['swiperContainer in_inner g-cf']" :style="i.zinStyle">
						<div :id="i.allId" class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(it,index) in i.labelTitle" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" :style="it.layoutOuterStyle">
									<div v-if="it.curObj&&it.curObj.item==1" class="area_conn sw" :style="it.zinStyle">
										<template v-for="(imy,inde) in it.itemInner">
											<mConet v-if="imy.isShow" :itemMdata="imy" :key="inde" :itemInner="it.itemInner"></mConet>
										</template>
									</div>
									<div v-if="it.curObj&&it.curObj.item==2" class="area_conn" :style="it.zinStyle">

										<template v-for="(imy,inder) in it.columnTitle1">
											<div class="ar_conn" :style="{width:imy.styleCon.width}" :class="['clm_pic',{'enter':it.isStreamColumn},'clm_pic'+inder]" v-if="imy.isShow">
												<div class="a_conn" :style="{padding:imy.styleCon.padding}">
													<template v-for="(inh,ind) in imy.itemInner">
														<mConet v-if="inh.isShow" class="outmodule" :itemMdata="inh" :key="ind" :itemInner="imy.itemInner"></mConet>
													</template>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
						<!-- 如果需要分页器 -->
						<div class="swiper-pagination"></div>
						<!-- 如果需要导航按钮 -->
						<!--div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div-->
						<!-- 如果需要滚动条 -->
						<div class="swiper-scrollbar"></div>
					</div>

				</template>
			</div>
		</div>
		<div class="artD hove_con">
			<template v-for="(i,index) in getDataCur.artD">
				<!--弹窗容器-->
				<div :id="i.allId" v-show="i.isShow" class="popUpsLayout">
					<div class="art_m_bg"></div>
					<div class="art_m_outer" :style="i.zinStyle">
						<div class="art_m_inner" :style="i.layoutOuterStyle">
							<div class="move_art header" :style="i.headStyle">
								<span class="tit" v-if="i.isHead">{{i.mTxt}}</span>
								<img class="close_icon" :src="i.mImage1.url||'https://diy.xiaohucloud.com/static/image/img/close_icon.png'" />
							</div>
							<div :style="i.conStyle" class="con_style">
								<mConet v-for="(irt,iex) in i.itemInner" :class="[{outmodule:irt.fullScreen}]" :key="iex" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner"></mConet>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<!--uiDialog v-if="editDial.isEdit" :itemMdata="itemMdata" @isFuncur="isFuncur" :editDial='editDial'></uiDialog-->
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	/*let mName = ['mFont', 'mImage', 'mButton', 'graphic', 'mNewDes', 'columnPicture', 'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'articleScrap', 'productNav', 'newlyShop', 'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite', 'areaLocation', 'areaMap', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit', 'siteForm', 'serviceOnline', 'siteQrCode', 'zhaopin', 'uiDialog', 'zhaopinDetail', 'mltilingual', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'];
	let ov = {};
	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('./m/' + mName[m] + '.vue');
	}*/
	import mConet from './mConet.vue'
	//import uiDialog from './m/uiDialog.vue'
	//	ov["mConet"] =mConet;
	export default {
		name: 'xIndex',
		components: {
			mConet
			//	uiDialog
		},
		props: [],
		updated: function() {
			this.$nextTick(function() {
				// console.log("$nextTick")
			})
		},
		data() {
			return {
				isMultiColumn: false,
				isConLeave: false,
				id: this.$route.params.id,
				x: 0,
				y: 'y',
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					column_id: this.$route.query.column_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					version_id: this.$route.query.pc_version_id
				},
				itemMdata: {},
				editDial: {},
				isAddNew: false,
				contextMenuData: {
					// the contextmenu name(@1.4.1 updated)
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					//Menu options (菜单选项)
					menulists: [{
							fnHandler: 'moveDownFloor',
							btnName: '设置为全站模块'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						}
					]
				}
			}
		},
		methods: {
			gotoSaveCom() {
				var html = $("#app").html();
				var ts = this;
				if(ts.$route.name == 't1') {
					ts.param.version_id = ts.$route.query.pc_version_id;
				} else {
					ts.param.version_id = ts.$route.query.mobile_version_id;
				}

				ts.param.html = html;
				ts.saveData(ts.param);

			},
			fluidFun(e) {
				let ts = this;
				for(var v in ts.getDataCur.stream) {
					var dataCur = ts.getDataCur.stream[v];
					if(dataCur.itemInner) {
						for(var i = 0; dataCur.itemInner.length > i; i++) {
							if(dataCur.itemInner[i].parentStyle) {
								dataCur.itemInner[i].parentStyle.active = false;
							}
						}
					} else if(dataCur.tName == 'labelContainer') {
						for(var j = 0; dataCur.labelTitle.length > j; j++) {
							let itemCur = dataCur.labelTitle[j];
							for(var i = 0; itemCur.itemInner.length > i; i++) {
								if(itemCur.itemInner[i].parentStyle) {
									itemCur.itemInner[i].parentStyle.active = false;
								}
							}
						}
					}
				}
			},

			setLabelItem(i, item) {
				if(i.labelStyle == 2) {
					for(let k = 0; i.labelTitle.length > k; k++) {
						i.labelTitle[k].cur = false;
					}
					item.cur = true;
					i.curItem = item.curItem;
				}
			},
			enterStyle(i, ite, index, e) {
				e.target.style.color = i.labelTitleStyleHover.color;
				e.target.style.background = i.labelTitleStyleHover.background;
				e.target.style.borderColor = i.labelTitleStyleHover.borderColor;
			},
			leaveStyle(i, ite, index, e) {
				if(ite.cur == false) {
					e.target.style.color = i.labelTitleStyle.color;
					e.target.style.background = i.labelTitleStyle.background;
					e.target.style.borderColor = i.labelTitleStyle.borderColor;
				}
			},
			getDataFree(v) {
				let ts = this;
				ts.getDataCur.stream[v.el].draging = true;
				ts.getDataCur.stream[v.el].conStyle.height = v.height;
			},
			removeComponent(comp) {
				this.delItemStream(comp);
				/*var stream = this.getDataCur.stream;
				for(var j = 0; stream.length > j; j++) {
					var itemInner = stream[j].itemInner;
					if(itemInner && itemInner.length) {
						itemInner.splice(itemInner.indexOf(comp), 1);
					}
				}*/
			},
			...mapMutations(['setDelayed', "getAllSite"]),
			...mapActions([
				"getData", "saveData"
			])
		},
		mounted() {
			// console.log( this.getDataCur.stream);
			let ts = this;

			setTimeout(function() {
				for(var v in ts.getDataCur.stream) {
					var dataCur = ts.getDataCur.stream[v];
					if(dataCur.tName == "labelContainer") {
						//debugger
						hoverAction.labelHover("#labelContainerId" + v, dataCur);
					} else if(dataCur.tName == "swiperContainer") {
						hoverAction.swiperHover(dataCur.allId, dataCur);
					}
				}
				urlLink.initLoad(ts.param.company_id);
			}, 400);
			//this.gotoSaveCom();
		},
		beforeCreate() {
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.src = "/static/js/pcemit.js";
			document.body.appendChild(s);
			var creatHead = $('head'),
				url = '/static/css/pcwebout.css';
			creatHead.append('<link rel="stylesheet" href="' + url + '" />');
			//debugger
		},
		created() {
			var creatHead = $('head'),
				url = '/static/css/pcwebout.css';
			creatHead.append('<link rel="stylesheet" href="' + url + '" />');
			let ts = this;
			ts.getData(ts.param);
			//var temp = this.$route.params.param;
			//this.setDelayed(temp);			
			function unScroll() {
				var top = $(document).scrollTop();
				$(document).on('scroll.unable', function(e) {
					$(document).scrollTop(top);
				})
			}

			function removeUnScroll() {
				$(document).unbind("scroll.unable");
			}

			var objAll = {
				id: ts.param.id,
				type: ts.param.type,
				token: ts.param.token,
				column_id: ts.param.version_id + "000",
				version_id: ts.param.version_id
			}
			ts.getAllSite(objAll);

			$("body").bind('keyup', function(event) {
				var itCur = {};
				event.preventDefault();
				for(var v in ts.getDataCur) {
					var dataCur = ts.getDataCur[v];
					//console.log(dataCur);
					//hoverAction.labelHover(dataCur);
					//hoverAction.labelSelected(dataCur);
					for(let j = 0; j < dataCur.length; j++) {
						var arSpon = dataCur[j];
						// console.log(arSpon)

						if(arSpon.mClass == 'Typesetting') {
							var itemInner = arSpon.itemInner;
							var labelTitle = arSpon.labelTitle;
							if(itemInner) {
								for(let k = 0; k < itemInner.length; k++) {
									if(itemInner[k].parentStyle.active) {
										itCur = itemInner[k];
									}
								}
							} else if(labelTitle) {
								for(let k = 0; k < labelTitle.length; k++) {
									if(labelTitle[k].itemInner) {
										var dtin = labelTitle[k].itemInner;
										for(let k = 0; k < dtin.length; k++) {
											if(dtin[k].parentStyle.active) {
												itCur = dtin[k];
											}
										}
									}
								}
							}

						} else {
							if(arSpon.tName == "moduleAreaNav") {
								if(arSpon.parentStyle.active) {
									itCur = ts.router;
								}
							} else if(arSpon.parentStyle.active) {
								itCur = arSpon;
							}
						}
					}
				}

				if(JSON.stringify(itCur) === '{}') {
					return;
				}
				if(event.keyCode == 37) {
					itCur.isShow = false;
					itCur.parentStyle.left -= 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 38) {
					itCur.isShow = false;
					itCur.parentStyle.top -= 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 39) {
					itCur.isShow = false;
					itCur.parentStyle.left += 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 40) {
					itCur.isShow = false;
					itCur.parentStyle.top += 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				}
			}).bind("keydown", function() {
				unScroll();
			}).bind("click", function() {
				removeUnScroll();
			});

		},
		computed: {
			...mapGetters(["getDataCur", "state", "router"])
		}
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/t1/prev/index.vue